import React from 'react'
import Image from 'next/image'

import Title from '../Title'
import s from './ourPartners.module.scss'

const BRANDS = ['accredited', 'wpa', 'pet', 'swiftest']

const OurPartners = () => {
  return (
    <div className={s.partner}>
      <Title variant="h2">Our Partners Include</Title>

      <section className={s.brands}>
        {BRANDS.map((elem, i) => (
          <div key={i}>
            <Image
              className={s.image}
              width={200}
              height={72}
              src={`/truspilot/${elem}.svg`}
              alt={`${elem} brand `}
            />
          </div>
        ))}
      </section>
    </div>
  )
}

export default OurPartners
